import { useIntl } from '@leagueplatform/locales';
import { ParagraphText } from '@leagueplatform/genesis-core';
import {
  InfoSection,
  InfoValueText,
} from 'components/info-section/info-section.component';

// Read-only Communication preferences card. The contact values come from the
// communication-preferences GET (see the Personal Info page) — never from the
// user profile. Empty fields fall back to "Not specified" via InfoRow; when the
// GET fails (`hasError`), the rows are replaced with a retrieval error message.
// `editLinkTo` turns the card's Edit affordance into a link out to the full
// Communication Preferences screen.
export const CommunicationPreferencesSection = ({
  mobilePhone,
  preferredPhone,
  email,
  editLinkTo,
  hasError = false,
}: {
  mobilePhone?: string;
  preferredPhone?: string;
  email?: string;
  editLinkTo?: string;
  hasError?: boolean;
}) => {
  const { formatMessage } = useIntl();

  return (
    <InfoSection
      heading={formatMessage({ id: 'STR_COMMUNICATION_PREFERENCES' })}
      editLinkTo={editLinkTo}
      compactLabels
      body={
        hasError ? (
          // role="alert" so screen readers announce the error when it swaps in
          // after the async comm-prefs GET fails on the already-rendered page.
          <ParagraphText role="alert" css={{ typography: '$bodyTwo' }}>
            {formatMessage({ id: 'STR_COMM_PREF_RETRIEVE_ERROR' })}
          </ParagraphText>
        ) : undefined
      }
      rows={[
        {
          id: 'mobile-phone',
          label: formatMessage({ id: 'STR_MOBILE_PHONE_NUMBER' }),
          value: mobilePhone ? (
            <InfoValueText>{mobilePhone}</InfoValueText>
          ) : undefined,
        },
        {
          id: 'preferred-phone',
          label: formatMessage({ id: 'STR_PREFERRED_PHONE_NUMBER' }),
          value: preferredPhone ? (
            <InfoValueText>{preferredPhone}</InfoValueText>
          ) : undefined,
        },
        {
          id: 'email',
          label: formatMessage({ id: 'STR_EMAIL_ADDRESS' }),
          value: email ? <InfoValueText>{email}</InfoValueText> : undefined,
        },
      ]}
    />
  );
};
